export default __webpack_public_path__ + "assets/webgl/complete-10.87e81784.jpg";